export default __webpack_public_path__ + "images/right-arrow.svg?533a6b3bf2c1f9c822ada96bd09b8636";